import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export type LogLevel = 'debug' | 'info' | 'warn' | 'error' | 'none';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private readonly levelPriority: Record<Exclude<LogLevel, 'none'>, number> = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3
  };

  private shouldLog(level: Exclude<LogLevel, 'none'>): boolean {
    const configuredLevel = (environment.logLevel || 'none') as LogLevel;

    if (configuredLevel === 'none' || !environment.enableConsoleLogs) {
      return false;
    }

    return this.levelPriority[level] >= this.levelPriority[configuredLevel as Exclude<LogLevel, 'none'>];
  }

  debug(message?: any, ...optionalParams: any[]): void {
    if (this.shouldLog('debug')) {
      console.debug(message, ...optionalParams);
    }
  }

  info(message?: any, ...optionalParams: any[]): void {
    if (this.shouldLog('info')) {
      console.info(message, ...optionalParams);
    }
  }

  warn(message?: any, ...optionalParams: any[]): void {
    if (this.shouldLog('warn')) {
      console.warn(message, ...optionalParams);
    }
  }

  error(message?: any, ...optionalParams: any[]): void {
    if (this.shouldLog('error')) {
      console.error(message, ...optionalParams);
    }
  }
}
